/** Për Data Logger / Energy Meter: shfaqje MW/MWh/MVAR vs kW/kWh/kVAR (pa ndikuar portin ose tensionin). */

export function normalizeDisplayPowerUnit(u) {
  const s = String(u ?? 'mw').trim().toLowerCase();
  return s === 'kw' ? 'kw' : 'mw';
}

export function powerEnergyLabels(displayUnit) {
  return normalizeDisplayPowerUnit(displayUnit) === 'kw'
    ? { power: 'kW', reactive: 'kVAR', energy: 'kWh' }
    : { power: 'MW', reactive: 'MVar', energy: 'MWh' };
}

/** Titull kartash fuqie: "Prodhimi" + njësi nga display_power_unit (kW / MW). */
export function formatPowerCardHeading(title, displayUnit) {
  const { power } = powerEnergyLabels(displayUnit);
  return `${title} (${power})`;
}

/** Vlerë numerike në kW → string për kartë sipas display_power_unit (si grafiku). */
export function formatPowerKwForCard(kw, displayUnit) {
  const n = Number(kw);
  if (!Number.isFinite(n)) return '—';
  if (normalizeDisplayPowerUnit(displayUnit) === 'kw') {
    return n.toFixed(2);
  }
  return (n / 1000).toFixed(3);
}

/** Grafiku mban vlerat në kW; mw → etiketa MW, kw → kW */
export function chartPowerTickLabel(v, displayUnit) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  return normalizeDisplayPowerUnit(displayUnit) === 'mw'
    ? `${(n / 1000).toFixed(3)} MW`
    : `${n.toFixed(3)} kW`;
}

/** Delta eksporti në grafik: v në MWh → MW shfaq MWh, kW shfaq kWh */
export function chartEnergyDeltaTickLabel(v, displayUnit) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  return normalizeDisplayPowerUnit(displayUnit) === 'kw'
    ? `${(n * 1000).toFixed(1)} kWh`
    : `${n.toFixed(3)} MWh`;
}
